import React from 'react';

import { Button } from '@interlayer/js/components/common/Button';
import I18n from '@interlayer/js/components/common/I18n';

import { useTranslations } from '@core/js/hooks/i18n';
import { clsb } from '@core/js/utils/classNames.util';

import { BUTTON_FINISH_CLASS } from '@interlayer/js/app/components/main/Registration/constants';
import { useRegistrationSelector } from '@interlayer/js/app/store/hooks/useRegistrationSelector';
import { clsx } from '@interlayer/js/app/utils/clsx.util';

import { TButtonNextProps } from './types';

import style from './ButtonNext.scss';

export const ButtonNext: React.FC<TButtonNextProps> = ({ disabled, classNames = {}, type = 'submit', onClick, isLoading, isFinishRegistration }) => {
    const { registrationNameStep } = useRegistrationSelector();
    const buildCls = clsb([style, classNames]);
    const t = useTranslations('playtech.mobile.system.registration.');

    return (
        <div className={buildCls(['wrap'])}>
            <Button
                type={type}
                size="medium"
                className={clsx(buildCls(['button']), { [BUTTON_FINISH_CLASS]: isFinishRegistration })}
                disabled={disabled}
                onClick={onClick}
                isLoading={isLoading}
            >
                <I18n
                    t={t}
                    tKey={`${registrationNameStep}.button`}
                    defaultValue={t('button.next')}
                />
            </Button>
        </div>
    );
};
